// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__5Q0e6","img":"style_img__05NJo"};